/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/dashboard',['../localization/labels', './util'], function(labels, util) {
    'use strict';

    var dashboardTitleStyle = {
        margin: [0, 5, 0, 0],
        fontSize: 14
    };

    return {
        dashboardTitleStyle: dashboardTitleStyle,
        constructDashboardWidgets: constructDashboardWidgets
    };

    /**
     * Function to create all dashboard widgets
     * @param  raw data for all dashboard widgets
     * @return widgets formatted according to pdfmake format
     */
    function constructDashboardWidgets(dashboardWidget) {
        var formattedWidgets = [], //widgets according to pdfmake format
            duration = dashboardWidget.duration,
            durationStr = (
                '(' + duration + ' ' +
                labels.others[duration === 1 ? 'DAY' : 'DAYS'] + ') ' +
                dashboardWidget.durationRange
            );

        dashboardWidget.widgetData.forEach(function(widget) {
            formattedWidgets.push(getDashboardWidget(widget));
        });

        return [{
                columns: [{
                    text: labels.dashboard.title,
                    fontSize: 18,
                    alignment: 'left'
                }, {
                    text: durationStr,
                    fontSize: 11,
                    alignment: 'right',

                }],
            },
            formattedWidgets,
        ];
    }
    /**
     * funtion to construct individual widgets of dashboard
     * @param  raw data for single widget of dashboard
     * @return array of javascript objects
     */
    function getDashboardWidget(widget) {
        // shrinking image to (2/3)rd
        util.shrinkImage(widget.image);

        return [{
            columns: [{
                text: widget.title1,
                style: 'dashboardTitleStyle'
            }, {
                text: widget.title2,
                style: 'dashboardTitleStyle'
            }]
        }, {
            table: {
                body: [
                    [{
                        image: widget.image.image,
                        width: widget.image.width,
                        height: widget.image.height,
                        margin: [-3, 0, 0, 0]
                    }]
                ]
            },
            layout: {
                hLineWidth: function() {
                    return 0;
                },
                vLineWidth: function() {
                    return 0;
                },
                hLineColor: function() {
                    return '#e5e5e5';
                },
                vLineColor: function() {
                    return '#e5e5e5';
                }
            },
            margin: [0, 0, 0, 0],
        }];
    }
});
